import gql from 'graphql-tag';
import { ECHELON_INFO_FRAGMENT } from '../echelon/fragment';
import { ENTITY_FRAGMENT } from '../entity/fragment';
import { ENSEIGNE_INFO_FRAGMENT } from './fragment';

export const GET_ENSEIGNE = gql`
  query GetEnsigne($input: GetEnseigneInput!) {
    getEnseigne(input: $input) {
      ...EnseigneInfo
    }
  }
  ${ENSEIGNE_INFO_FRAGMENT}
`;

export const GET_ALL_ENSEIGNES = gql`
  query AllEnseignes($input: AllEnseignesInput) {
    allEnseignes(input: $input) {
      totalCount
      enseignes {
        ...EnseigneInfo
        entities {
          ...EntityInfo
          echelon {
            ...EchelonInfo
          }
        }
      }
    }
  }
  ${ENSEIGNE_INFO_FRAGMENT}
  ${ENTITY_FRAGMENT}
  ${ECHELON_INFO_FRAGMENT}
`;

export const GET_ENSEIGNES_WITH_ENTITIES = gql`
  query EnseignesWithEntities($input: AllEnseignesInput) {
    allEnseignes(input: $input) {
      totalCount
      enseignes {
        id
        name
        # entities {
        #   id
        #   name
        #   echelon {
        #     id
        #     name
        #     priority
        #   }
        # }
      }
    }
  }
`;

export const GET_MINIMAL_ENSEIGNES = gql`
  query MinimalEnseignes($input: AllEnseignesInput) {
    allEnseignes(input: $input) {
      totalCount
      enseignes {
        id
        name
        type
      }
    }
  }
`;
